export default {
  convertLoggedInUserInPageResourcesToMap(loggedInUserResourcesInStore, page) {
    const flattenResourcesMap = {};

    page.inPageResources.forEach((inPageResource) => {
      inPageResource.groups.forEach((group) => {
        group.resources.forEach((resource) => {
          const foundResource = loggedInUserResourcesInStore.find((loggedInUserResourceInStore) => loggedInUserResourceInStore.tag === resource.tag);
          if (foundResource) {
            flattenResourcesMap[foundResource.tag] = foundResource.tag;
          }
        });
      });
    });

    return flattenResourcesMap;
  },

  getLoggedInUserInPageResources(page, loggedInUserResourceMap) {
    page.inPageResources.forEach((resource) => {
      resource.groups.forEach((group) => {
        group.resources.forEach((resource) => {
          resource.existsInLoggedInUserResources = loggedInUserResourceMap[resource.tag];
        });
      });
    });
    return page;
  },

  setLoggedInUserMenuResources(pages, loggedInUserResourceMap) {
    function checkResourceAvailability(node, resourceMap) {
      if (!node || !node.children) return resourceMap[node.pagePermissionTag] || false;

      let isResourceAvailable = false;

      node.children.forEach((child) => {
        if (checkResourceAvailability(child, resourceMap)) {
          node.existsInLoggedInUserResources = true;
          isResourceAvailable = true;
        }
      });

      return isResourceAvailable || resourceMap[node.pagePermissionTag] || false;
    }

    pages.forEach((page) => {
      if (checkResourceAvailability(page, loggedInUserResourceMap)) {
        page.existsInLoggedInUserResources = true;
      }
    });
  },

  loggedInUserHasAnyResourceInGroups(page, correlationKey) {
    const inPageResources = page.inPageResources.find((inPageResource) => inPageResource.correlationKey === correlationKey);
    if (!inPageResources) return false;

    const flattenedResources = inPageResources.groups.reduce((acc, group) => {
      return acc.concat(group.resources);
    }, []);

    if (!flattenedResources) return false;

    return flattenedResources.filter((resource) => resource.existsInLoggedInUserResources).length > 0;
  },

  loggedInUserHasAnyResourceInGroup(page, correlationKey, groupCorrelationKey) {
    const inPageResources = page.inPageResources.find((inPageResource) => inPageResource.correlationKey === correlationKey);

    if (!inPageResources) return false;

    const group = inPageResources.groups.find((group) => group.correlationKey === groupCorrelationKey);

    if (!group) return false;

    return group.resources.filter((resource) => resource.existsInLoggedInUserResources).length > 0;
  },

  getResourceGroupTitle(page, correlationKey, groupCorrelationKey) {
    const inPageResources = page.inPageResources.find((inPageResource) => inPageResource.correlationKey === correlationKey);

    if (!inPageResources) return null;

    const group = inPageResources.groups.find((group) => group.correlationKey === groupCorrelationKey);

    if (!group) return null;

    return group.title;
  },

  findLoggedInUserResourcesInGroup(page, correlationKey, groupCorrelationKey) {
    const inPageResources = page.inPageResources.find((inPageResource) => inPageResource.correlationKey === correlationKey);
    if (!inPageResources) return null;

    const group = inPageResources.groups.find((group) => group.correlationKey === groupCorrelationKey);
    if (!group) return null;

    return group.resources.filter((resource) => resource.existsInLoggedInUserResources);
  },

  getLoggedInUserResourcesTitlesInGroup(page, correlationKey, groupCorrelationKey) {
    const inPageResources = page.inPageResources.find((inPageResource) => inPageResource.correlationKey === correlationKey);
    if (!inPageResources) return null;

    const group = inPageResources.groups.find((group) => group.correlationKey === groupCorrelationKey);
    if (!group) return null;

    return group.resources
      .filter((resource) => resource.existsInLoggedInUserResources)
      .map((resource) => resource.title)
      .join(", ");
  },
};
